import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const iconButtonDriverFactory = (base: UniDriver) => {
  return {
    /** @private */
    _base: base,
    ...baseUniDriverFactory(base),
    focus: async () => (await base.getNative()).focus(),
  };
};

export type IconButtonDriver = ReturnType<typeof iconButtonDriverFactory>;
